<div class="card-footer clearfix d-flex justify-content-sm-between justify-content-center flex-sm-row flex-column align-items-center">
    <div class="dataTables_length m-0" id="tableDeudores_length">
        <label>Mostrando <select [(ngModel)]="itemsPerPage" (change)="itemsPerPageChanged($event)"
                name="tableDeudores_length" aria-controls="tableDeudores" style="width: 70px;"
                class="custom-select custom-select-sm form-control form-control-sm">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <!-- <option [value]="totalItems">Todo</option> -->
            </select> registros</label>
    </div>
    <pagination class="pagination m-0" [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="page"
        (pageChanged)="pageChanged($event)" [boundaryLinks]="true" [rotate]="true" [maxSize]="5" previousText="&lsaquo;" nextText="&rsaquo;"
        firstText="&laquo;" lastText="&raquo;"></pagination>
</div>